<template>
    <footer class="footer">
        <v-container>
            <v-row no-gutters align="center" class="page-text">
                <v-col cols="12" md="">
                    <p class="font-size-16 grey--text text--darken-4 font-weight-medium mb-8 mb-md-12 mb-lg-16 font-pretendard">(주)모두에프엔티</p>
                    <ul class="footer-info d-flex page-text--xs">
                        <li class="mr-16 mb-6 mb-md-0">
                            <span class="grey--text">Address.</span> 
                            경기도 하남시 창우로 38-35번지
                        </li>
                        <li class="mr-16  mb-6 mb-md-0">
                            <span class="grey--text">Tel.</span> 
                            02-487-7350
                        </li>
                        <li class="mr-16 mb-6 mb-md-0">
                            <span class="grey--text">Fax.</span> 
                            02-486-2189
                        </li>
                        <li>
                            <span class="grey--text">E-mail.</span> MODOO456@NAVER.COM
                        </li>
                    </ul>
                    <p class="mt-8 page-text--xs">Copyright 2023. 모두에프엔티 CO.,Ltd. All Rights Reserved.</p>
                </v-col>
                <v-col cols="12" md="auto">
                    <v-img src="/images/logo.svg" class="logo mt-16 mt-md-0"></v-img>
                    <!-- <v-select large hide-details outlined placeholder="Family Site" append-icon="mdi-chevron-down" class="familysite"
                    :items="sites" item-text="name" item-value="link" v-model="site" @change="changeD">
                    </v-select> -->
                    <div class="sns">
                        <!-- <v-btn fab small class="grey mr-12" href="https://www.instagram.com/modoofnt/" target="_blank">
                            <v-img max-width="18" src="/images/icon/icon-insta.png"></v-img>
                        </v-btn> -->
                        <v-btn fab small class="grey" href="https://blog.naver.com/modoofnt" target="_blank">
                            <v-img max-width="20" src="/images/icon/icon-blog.png"></v-img>
                        </v-btn>
                    </div>
                    <!-- <u-scroll-top class="mt-md-auto ml-md-auto"></u-scroll-top> -->
                </v-col>
                <!-- <v-col cols="12" md="auto" class="d-flex">
                    <u-scroll-top class="mt-auto ml-auto"></u-scroll-top>
                </v-col> -->
            </v-row>
        </v-container>
        <u-scroll-top></u-scroll-top>
    </footer>
</template>

<script>
import UScrollTop from "@/components/dumb/u-scroll-top.vue";
import api from "@/api";

export default {
    components: {
        UScrollTop,
    },
    data() {
        return {
            setting: null,
        };
    },
    computed: {
        info() {
            return this.setting?.footer?.info || [];
        },
        sns() {
            return (this.setting?.footer?.sns || []).filter(({ shows }) => shows);
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            const { setting } = await api.v1.setting.get();
            this.setting = setting;
        },
    },
};
</script>

<style scoped>
</style>
